import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ALL_TABS = [
  { to: "/admin/inventory", label: "Inventory List", roles: ["admin", "inventory_manager"] },
  { to: "/admin/inventory/usage", label: "Daily Usage Entry", roles: ["admin", "inventory_manager", "staff"] },
  { to: "/admin/inventory/receive", label: "Receive Stock", roles: ["admin", "inventory_manager"] },
  { to: "/admin/inventory/reports", label: "Reports", roles: ["admin", "inventory_manager"] },
  { to: "/admin/inventory/import", label: "Import Workbook", roles: ["admin"] },
  { to: "/admin/inventory/import-history", label: "Import History", roles: ["admin"] },
  { to: "/admin/inventory/settings", label: "Drawers & Categories", roles: ["admin"] },
];

export default function InventorySubNav() {
  const { user } = useAuth();
  const location = useLocation();
  const tabs = ALL_TABS.filter((t) => t.roles.includes(user?.role));

  return (
    <div className="flex gap-2 mb-6 flex-wrap" data-testid="inventory-subnav">
      {tabs.map((t) => (
        <Link
          key={t.to}
          to={t.to}
          data-testid={`inventory-subnav-${t.to.split("/").pop()}`}
          className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
            location.pathname === t.to ? "bg-amtm-teal text-white" : "bg-amtm-surface border border-amtm-border text-amtm-textMuted hover:bg-amtm-bg"
          }`}
        >
          {t.label}
        </Link>
      ))}
    </div>
  );
}
